/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Query, onSnapshot } from 'firebase/firestore';
import { isEqual } from 'lodash';

type Listener = () => void;

interface StoreEntry<T> {
  data: T[];
  listeners: Set<Listener>;
  unsubscribe?: () => void;
}

const store = new Map<string, StoreEntry<any>>();
const EMPTY_ARRAY: any[] = [];

export function subscribeToQuery<T extends { id: string }>(
  key: string,
  query: Query,
  listener: () => void,
) {
  let entry = store.get(key) as StoreEntry<T> | undefined;

  if (!entry) {
    entry = {
      data: [],
      listeners: new Set(),
    };

    entry.unsubscribe = onSnapshot(query, (snapshot) => {
      const newData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      })) as T[];

      if (!isEqual(entry!.data, newData)) {
        entry!.data = newData;
        entry!.listeners.forEach((l) => l());
      }
    });

    store.set(key, entry);
  }

  entry.listeners.add(listener);

  return () => {
    entry!.listeners.delete(listener);

    if (entry!.listeners.size === 0) {
      entry!.unsubscribe?.();
      store.delete(key);
    }
  };
}

export function getSnapshot<T>(key: string): T[] {
  const entry = store.get(key);
  return entry?.data ?? EMPTY_ARRAY;
}
